import React, { Component } from 'react';
import { adminReport } from '../../API/FetchCall';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import CsvDownload from 'react-json-to-csv';
class AllReports extends Component {

  constructor(props) {
    super(props);
    this.state = {
      report_list: [],
      download_report: [],
      show: false
    }
    this.getReports();
  }
  getReports = () => {
    let req = JSON.stringify({
      url: 'get_report_drop'
    })
    adminReport(req).then(res => {
      if (res.status === 1) {
        this.setState({
          report_list: res.list
        })
      }
    })
  }
  componentDidMount() {

  }

  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh')
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  render() {
    return (
      <React.Fragment>
        <div className=" col-md-8 col-xs-8">
          <form onSubmit={this.handleSubmit} autoComplete='off'>
            <div className='row form-group'>
              <div className='col-md-4'>
                <label>Select Report</label><br/>
                <select className='selectpicker form-control' title='Select Report'
                  name='report' value={this.state.report} onChange={this.handleChange}>
                  {this.state.report_list.map((item, i) => {
                    return (
                      <option value={item.ref_name}>{item.report_name}</option>
                    )
                  })}
                </select>
              </div>
              <div className='col-md-4 report-date'>
                <label>Select From Date</label><br/>
                <DatePicker
                  autocomplete="off"
                  onChange={(date) => this.setState({ start_date: date })}
                  className='form-control input-group-date'
                  selected={this.state.start_date}
                  name="start_date"
                  id="start_date"
                  dateFormat="yyyy-MM-dd"
                  required
                />
              </div>
              <div className='col-md-4 report-date'>
                <label>Select To Date</label><br/>
                <DatePicker
                  autocomplete="off"
                  onChange={(date) => this.setState({ end_date: date })}
                  className='form-control input-group-date'
                  selected={this.state.end_date}
                  name="end_date"
                  id="end_date"
                  dateFormat="yyyy-MM-dd"
                  required
                />
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-12 text-center"><button className='btn btn-primary btn-sm mb-2'>Submit</button></div>
            </div>
            <div className='row form-group'>
              <div className='col-md-6 text-left'>
                {this.state.download_report.length > 0 &&
                  <CsvDownload data={this.state.download_report} className='btn btn-success' />
                }
              </div>
            </div>
          </form>
        </div>
      </React.Fragment >
    )
  }
  download = () => {
    this.setState({
      show: false
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    let req = JSON.stringify({
      report: this.state.report,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      url: 'get_report'
    })
    adminReport(req).then(res => {
      if (res.status === 1) {
        if (res.result.length > 0) {
          this.setState({
            download_report: res.result,
            show: true
          })
        } else {
          let toastr = '';
          toastr = window.toastr.warning;
          toastr('No Data Found', toastr, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
        }
      }
    })
  }
}


export default AllReports;


// WEBPACK FOOTER //
// ./src/components/bewise/All_reports.jsx